import { mapEdgeCategoryToCategory } from '@modules/common/utils';
import dayjs from 'dayjs';
import { LabelFragmentFragment } from 'generated/graphql';
import { EntityLabel, L1Label, ReasonLabel } from 'v2/core/entities/labels';
import { LabelType } from 'v2/core/entities/taxonomy';
import { mapSentimentName } from 'v2/core/repository/edge-server/records/mapper';

export const toLabelType = (
  type?: 'Aspect' | 'Reason' | 'Cluster' | 'Sentiment' | 'L1',
): LabelType => {
  switch (type) {
    case 'L1':
      return LabelType.L1;
    case 'Aspect':
      return LabelType.Aspect;
    case 'Reason':
      return LabelType.Reason;
    case 'Cluster':
      return LabelType.Cluster;
    case 'Sentiment':
      return LabelType.Sentiment;
    default:
      throw Error(`unknown label type: ${type}`);
  }
};

export const getCreatedAt = (createdAt?: number) => {
  if (!createdAt) {
    return undefined;
  }

  return dayjs.unix(createdAt);
};

const mapCommonLabelData = (label: LabelFragmentFragment) => ({
  ...label,
  name: label.displayName,
  description: label.description ?? '',
  createdAt: getCreatedAt(label.createdAt),
  type: toLabelType(label.__typename),
});

export const mapLabelData = (
  label: LabelFragmentFragment,
): L1Label | EntityLabel | ReasonLabel => {
  switch (label.__typename) {
    case 'L1':
      return {
        ...mapCommonLabelData(label),
        type: LabelType.L1,
        metadata: {},
      };
    case 'Reason':
      if (label.metadata) {
        return {
          ...mapCommonLabelData(label),
          type: LabelType.Reason,
          metadata: {
            ...label.metadata,
            category: mapEdgeCategoryToCategory(label.metadata?.category),
            sentiment: label.metadata?.sentiment
              ? mapSentimentName(label.metadata?.sentiment)
              : undefined,
          },
        };
      }
      return {
        ...mapCommonLabelData(label),
        type: LabelType.Reason,
        metadata: {},
      };
    case 'Aspect':
      return {
        ...mapCommonLabelData(label),
        type: LabelType.Aspect,
        metadata: {
          phrases: label.metadata?.phrases,
          excludedPhrases: label.metadata?.excludedPhrases,
        },
      };
  }
  throw Error(`unknown label type ${label.__typename}`);
};
